<template>
  <div class="xy-center flex-y" style="width:100%;height:100%">
    <img src="https://oss.yf-gz.cn/file/1706595875413_73b20fec9b0d6a02c51ee4758fa48e22.png" alt="" style="width:196px;height:214px">
    <div class="empty-text">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
  },
}
</script>
<style lang="less" scoped>
.empty-text {
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: -38px;
}
.flex-y {
  flex-direction: column;
}

</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/empty.vue